<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.gasCabinetPara')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/gasCabinetPara"><span>{{$t('tlt.gasCabinetPara')}}</span></router-link></li>
                </ul>
            </div>
        </div>

        <section class="app-content"> 
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.startTime") }} :</label>
                                    <mmf-datepicker v-model="startTimeFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.endTime") }} :</label>
                                    <mmf-datepicker v-model="endTimeFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{$t('lbl.fm.locationName')}}：</label>
                                    <select class="form-control" v-model="locNameFilter">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                                        <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                                        <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                                    </select>
                                </div>

                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('gasCabinetPara')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('gasCabinetPara')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="gasCabinetParaTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="gasCabinetPara" inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToGasFlowPara()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.gasFlowPara')}}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/productionExecution/smelting/GasCabinetPara";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "gasCabinetPara/getField",
  mutationType: "gasCabinetPara/updateField"
});
export default {
    name: "gasCabinetParaList",
    data(){
        return {

        }
    },
    components: { MmfTable, MmfDatepicker },
    computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.gasCabinetPara.rows,
      tableColumns: gridFields,
      entity: state => state.gasCabinetPara.entity,
      checkedItems: state => state.gasCabinetPara.checkedItems,
      showNoResultAlert: state => state.base.showNoResultAlert
    })
    },
    methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    jumpToGasFlowPara() {
        this.$router.push("/prd/gasFlowPara");
    }
    },
    mounted() {}
}
</script>